






























































































import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
  Form,
} from "vant";
import WeMixin from "@/components/weMixin";
import api from "../../../components/http/api";
import { RegisterInfo } from "../user/UserApi";
import { CouponRequestInfo } from "./NyjwslApi";
import moment from "moment";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
    [Form.name]: Form,
  },
})
export default class NyjwslCoupon extends mixins(WeMixin) {
  private registerInfo: RegisterInfo = {} as RegisterInfo;
  private couponRequestInfo: CouponRequestInfo = {} as CouponRequestInfo;
  private rTime: number = 0;

  private buttonShow: boolean = false;
  private buttonActive: boolean = false;

  private isError: boolean = true;
  private isShowError: boolean = false;

  private errmsg: string = "";
  private errDialog: boolean = false;
  private errDialogFalse: boolean = false;

  protected created() {
    this.checkIsSubscribe();
  }

  protected checkIsok() {
    console.log(this.registerInfo);
    this.couponRequestInfo.openid = this.registerInfo.openid;
    this.couponRequestInfo.phone = this.registerInfo.phone;
    this.couponRequestInfo.orgid = this.registerInfo.orgid;
    this.couponRequestInfo.activityid = this.$route.params.activityid;
    api
      .post("/weixinmp/xsyx/coupon/getNyjwslIsok", this.couponRequestInfo)
      .then((res: any) => {
        if (res.data.flag) {
          this.errDialog = true;
          this.errmsg = "恭喜您本月已达标，请抽奖";
        } else {
          this.errDialogFalse = true;
          this.errmsg = "很遗憾您本月未达标，加油！";
          this.buttonActive = true;
        }
      });
  }

  protected checkIsSubscribe() {
    api.post("/weixinmp/xsyx/myuser/checkIsSubscribe", {}).then((res: any) => {
      if (!res.data) {
        this.buttonActive = true;
        this.isError = false;
        this.isShowError = true;
      } else {
        this.getCustomerInfo();
      }
    });
  }

  protected getCustomerInfo() {
    api.get("/weixinmp/xsyx/myuser/getCustomerInfo").then((res: any) => {
      if (res.data.flag === "0") {
        this.registerInfo = res.data;
        this.buttonShow = true;
        this.checkIsok();
      } else if (res.data.flag === "1") {
        const interval = window.setInterval(() => {
          if (--this.rTime <= 0) {
            window.clearInterval(interval);
            this.$router.replace(
              "/main/user/registerFromCouponAll/" +
                this.$route.params.activityid
            );
          }
        }, 2000);
      }
    });
  }

  protected getCouponFromNotify() {
    const beginday = moment().format("YYYYMMDD HH");
    const todayDay = moment().format("YYYYMMDD");
    if (todayDay > "20240531" || beginday < "20240510 09") {
      this.$toast({
        message: "请在5月10日9点-5月31日间进行抽奖",
        position: "bottom",
      });
    } else {
      this.couponRequestInfo.openid = this.registerInfo.openid;
      this.couponRequestInfo.phone = this.registerInfo.phone;
      this.couponRequestInfo.orgid = this.registerInfo.orgid;
      this.couponRequestInfo.activityid = this.$route.params.activityid;
      this.buttonActive = true;
      api
        .post(
          "/weixinmp/xsyx/coupon/getNyjwslActivityInfo",
          this.couponRequestInfo
        )
        .then((res: any) => {
          if (res.data.owner === "1") {
            // 498供应商
            window.location.href =
              process.env.VUE_APP_498_URL +
              encodeURIComponent(
                // "https://www.tongdatech.com:443/xsyx" +
                process.env.VUE_APP_URLFRONT +
                  "/main/coupon/getCouponFromNotifyResult498?a=" +
                  this.couponRequestInfo.orgid +
                  "&b=" +
                  this.couponRequestInfo.phone +
                  "&c=" +
                  this.couponRequestInfo.activityid +
                  "&d=" +
                  this.couponRequestInfo.openid
              );
          } else if (res.data.owner === "null") {
            this.$toast("该活动不存在，请联系工作人员");
          } else if (res.data.owner === "NOCUSINFO") {
            this.$toast("非当月达标客户无法抽奖");
          } else if (res.data.owner === "NOHD") {
            this.$toast("活动尚未开始");
          } else {
            this.$router.push(
              "/main/coupon/getCouponFromNotifyResult?a=" +
                this.couponRequestInfo.orgid +
                "&b=" +
                this.couponRequestInfo.phone +
                "&c=" +
                this.couponRequestInfo.activityid +
                "&d=" +
                this.couponRequestInfo.openid
            );
          }
        });
    }
  }

  protected toRegister() {
    this.$router.replace(
      "/main/user/registerFromCouponAll/" + this.$route.params.activityid
    );
  }

  protected toRaffle() {
    this.$router.go(0);
  }
}
